import $i18n from 'panda-i18n';
import React, { useContext } from 'react';
import { CnList } from '@/components/cn-list';
import { CnButton } from '@/components/cn-button';
import isFunction from 'lodash/isFunction';
import { CnSelector } from '@/components/cn-selector';
import { findInArray, isNil, isValidArray, mergeDataSource, replaceMessage, } from '@/utils/func';
import SelectContext from '../context';
import Option from '../option';
import { defaultLocalFilter, isSelected, removeItemFromArray } from '../util';
const sort = (arr, value) => {
    const selectedArr = [];
    const unSelectedArr = [];
    arr.forEach((item) => {
        if (isSelected(value, item.value)) {
            selectedArr.push(item);
        }
        else {
            unSelectedArr.push(item);
        }
    });
    return [...selectedArr, ...unSelectedArr];
};
const SelectBody = (props) => {
    const { prefix, size, displayType, disabled, mode, dataSource, filterLocal = true, stickyOnTop = true, filter = defaultLocalFilter, searchValue, innerValue, value, transferSearchToOption, onChange, onSearchAdd, renderItem, } = useContext(SelectContext);
    const { searchToOptionBtnText = '', emptySearchText = '' } = props;
    const renderWithTag = displayType === 'tag';
    const renderWithMenu = !renderWithTag && mode === 'single';
    const clsPrefix = `${prefix}select`;
    // 执行排序
    let filteredDataSource = filterLocal
        ? mergeDataSource(dataSource, [...value, ...innerValue]).filter((item) => {
            return filter(searchValue, item);
        }) // 内部过滤 dataSource
        : dataSource;
    if (mode === 'multiple' && stickyOnTop) {
        filteredDataSource = sort(filteredDataSource, value);
    }
    const emptySearchContent = (React.createElement("div", { className: `${clsPrefix}-search-empty` },
        React.createElement("span", { className: `${clsPrefix}-search-empty-tip` }, searchValue
            ? replaceMessage(emptySearchText, { searchVal: searchValue })
            : $i18n.get({
                id: 'PleaseEnterKeywordSearch',
                dm: '请输入关键词搜索',
                ns: 'CnSelect',
            }))));
    // 这里原先是Menu实现，由于没有给选中的选项加className，导致无法定制样式，因此放弃掉，改用统一的Option
    if (renderWithMenu) {
        if (isValidArray(filteredDataSource)) {
            const singleOptions = filteredDataSource.map((it) => (React.createElement(Option, { key: it.value, selected: isSelected(innerValue, it.value), disabled: disabled || it.disabled, multiple: false, onClick: () => {
                    const { onClick } = it;
                    if (isFunction(onClick)) {
                        onClick(it.value);
                    }
                    onChange([{ label: it.label, value: it.value }]);
                }, ...it }, typeof renderItem === 'function' ? renderItem(it) : it.label)));
            return React.createElement(CnList, null, singleOptions);
        }
        return emptySearchContent;
    }
    if (renderWithTag) {
        return (React.createElement("div", { className: `${prefix}select--tag ${prefix}select--tag-${size}` },
            React.createElement(CnSelector, { prefix: prefix, mode: mode, value: innerValue.map((it) => it.value), dataSource: filteredDataSource, onChange: (v) => {
                    if (isNil(v)) {
                        onChange([]);
                        return;
                    }
                    const newValue = Array.isArray(v) ? v : [v];
                    const newItems = newValue.map((x) => {
                        return findInArray(filteredDataSource, (item) => item.value === x);
                    });
                    onChange(newItems);
                } })));
    }
    const options = filteredDataSource.map((it) => (React.createElement(Option, { key: it.value, selected: isSelected(innerValue, it.value), disabled: disabled || it.disabled, onClick: () => {
            const selectedItem = findInArray(innerValue, (item) => item.value === it.value);
            if (selectedItem) {
                onChange(removeItemFromArray(innerValue, selectedItem.value));
            }
            else {
                onChange([
                    ...innerValue,
                    {
                        ...it,
                        label: it.label,
                        value: it.value,
                    },
                ]);
            }
        }, ...it }, typeof renderItem === 'function' ? renderItem(it) : it.label)));
    // 常规渲染
    // eslint-disable-next-line no-nested-ternary
    return transferSearchToOption ? (React.createElement(CnList, null,
        searchValue &&
            !findInArray(filteredDataSource, (it) => `${it.label}` === `${searchValue}`) && (React.createElement(Option
        // @ts-ignore
        , { 
            // @ts-ignore
            isNew: true, onClick: () => {
                if (onSearchAdd) {
                    onSearchAdd(searchValue, innerValue);
                }
                onChange([
                    ...innerValue,
                    {
                        label: searchValue,
                        value: searchValue,
                        userAdd: true,
                    },
                ]);
            } },
            React.createElement("div", { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                } },
                React.createElement("span", null, searchValue),
                React.createElement(CnButton, { size: "small", type: "secondary" }, searchToOptionBtnText)))),
        options)) : isValidArray(filteredDataSource) ? (React.createElement(CnList, null, options)) : (emptySearchContent);
};
export default SelectBody;
